import { CollapsibleSection } from "components/collapsibleSection";
import Input from "components/input";
import Select from "components/select";
import { ISportParticipantForm } from "interfaces";
import { Controller, useFormContext } from "react-hook-form";
import { EWAIVER_STATUS } from "utills/constants";

export const EditEwaiverInformationSection = () => {
  
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext<ISportParticipantForm>(); // retrieve all hook methods
  
  return (
    <CollapsibleSection 
      label="Ewaiver Information"
      defaultOpen={true}
    >
      <div className="grid gap-x-4 gap-y-6 px-4 py-4 text-sm sm:px-6 grid-cols-12 lg:gap-x-6" style={{wordBreak: "break-word"}}>
        <div className="grid gap-x-4 sm:grid-cols-6 gap-y-2 col-span-full sm:col-span-6 sm:order-1">
          <div className="sm:col-span-2">
            <p className="font-medium">
              Ewaiver status
            </p>
          </div>
          <div className="sm:col-span-4">
            <Controller
              control={control}
              name="online_checked"
              render={({ field: { onChange, value = [], ref } }) => (
                <Select
                  key="online_checked"
                  inputRef={ref}
                  options={EWAIVER_STATUS}
                  id="online_checked"
                  placeholder="Select Ewaiver Status"
                  defaultValue={
                    EWAIVER_STATUS.find(
                      (selected: { label: string; value: string }) =>
                        JSON.parse(selected.value) === value
                    ) ?? ""
                  }
                  value={EWAIVER_STATUS.find(
                    (selected: { label: string; value: string }) =>
                      JSON.parse(selected.value) === value
                  )}
                  onChange={(selected: { label: string; value: string }) => {
                    onChange(JSON.parse(selected?.value));
                  }}
                  error={errors["online_checked"]}
                />
              )}
            />
            {errors["online_checked"] ? (
              <p className="error-text">
                <span className="font-medium">
                  {errors["online_checked"]?.message}
                </span>
              </p>
            ) : null}
          </div>
        </div>
        <div className="grid gap-x-4 sm:grid-cols-6 gap-y-2 col-span-full sm:col-span-6 sm:order-3">
          <div className="sm:col-span-2">
            <p className="font-medium">
              Kyc by legal
            </p>
          </div>
          <div className="sm:col-span-4">
            <Controller
              control={control}
              name="kyc_by_legal"
              render={({ field: { onChange, value = true, ref } }) => (
                <Input
                  type="checkbox"
                  label=""
                  id="kyc_by_legal"
                  checked={value}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => 
                    onChange(e.target.checked)
                  }    
                />
              )}
            />
            {errors["kyc_by_legal"] ? (
              <p className="error-text">
                <span className="font-medium">
                  {errors?.kyc_by_legal.message}
                </span>
              </p>
            ) : null}
          </div>
        </div>
        <div className="grid gap-x-4 sm:grid-cols-6 gap-y-2 col-span-full sm:col-span-6 sm:order-5">
          <div className="sm:col-span-2">
            <p className="font-medium">
              Ocr time 
            </p>
          </div>
          <div className="sm:col-span-4">
            <Input
              id="ocr_time"
              type="number"
              min={0}
              placeholder="Ocr Time"
              error={errors["ocr_time"]}
              {...register("ocr_time", {
                valueAsNumber: true
              })}
            />
            {errors["ocr_time"] ? (
              <p className="error-text">
                <span className="font-medium">
                  {errors?.ocr_time.message}
                </span>
              </p>
            ) : null}
          </div>
        </div>
        <div className="grid gap-x-4 sm:grid-cols-6 gap-y-2 col-span-full sm:col-span-6 sm:order-7">
          <div className="sm:col-span-2">
            <p className="font-medium">
              Name pick
            </p>
          </div>
          <div className="sm:col-span-4">
            <Input
              id="name_pick"
              type="text"
              placeholder="Name pick"
              error={errors["name_pick"]}
              {...register("name_pick")}
            />
            {errors["name_pick"] ? (
              <p className="error-text">
                <span className="font-medium">
                  {errors?.name_pick.message}
                </span>
              </p>
            ) : null}
          </div>
        </div>
        <div className="grid gap-x-4 sm:grid-cols-6 gap-y-2 col-span-full sm:col-span-6 sm:order-9">
          <div className="sm:col-span-2">
            <p className="font-medium">
              Email pick
            </p>
          </div>
          <div className="sm:col-span-4">
            <Input
              id="email_pick"
              type="text"
              placeholder="Email pick"
              error={errors["email_pick"]}
              {...register("email_pick")}
            />
            {errors["email_pick"] ? (
              <p className="error-text">
                <span className="font-medium">
                  {errors?.email_pick.message}
                </span>
              </p>
            ) : null}
          </div>
        </div>
        <div className="grid gap-x-4 sm:grid-cols-6 gap-y-2 col-span-full sm:col-span-6 sm:order-11">
          <div className="sm:col-span-2">
            <p className="font-medium">
              Max number of times to update pickup method
            </p>
          </div>
          <div className="sm:col-span-4">
            <Input
              id="num_of_times_change_pickup"
              type="number"
              min={0}
              placeholder="Max number of times to update pickup method"
              error={errors["num_of_times_change_pickup"]}
              {...register("num_of_times_change_pickup", {
                valueAsNumber: true
              })}
            />
            {errors["num_of_times_change_pickup"] ? (
              <p className="error-text">
                <span className="font-medium">
                  {errors?.num_of_times_change_pickup.message}
                </span>
              </p>
            ) : null}
          </div>
        </div>
        <div className="grid gap-x-4 sm:grid-cols-6 gap-y-2 col-span-full sm:col-span-6 sm:order-2">
          <div className="sm:col-span-2">
            <p className="font-medium">
              Waiver sign completed
            </p>
          </div>
          <div className="sm:col-span-4">
            <Controller
              control={control}
              name="waiver_sign_completed"
              render={({ field: { onChange, value = true, ref } }) => (
                <Input
                  type="checkbox"
                  label=""
                  id="waiver_sign_completed"
                  checked={value}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => 
                    onChange(e.target.checked)
                  }    
                />
              )}
            />
            {errors["waiver_sign_completed"] ? (
              <p className="error-text">
                <span className="font-medium">
                  {errors?.waiver_sign_completed.message}
                </span>
              </p>
            ) : null}
          </div>
        </div>
        <div className="grid gap-x-4 sm:grid-cols-6 gap-y-2 col-span-full sm:col-span-6 sm:order-4">
          <div className="sm:col-span-2">
            <p className="font-medium">
              Kyc completed
            </p>
          </div>
          <div className="sm:col-span-4">
            <Controller
              control={control}
              name="kyc_completed"
              render={({ field: { onChange, value = true, ref } }) => (
                <Input
                  type="checkbox"
                  label=""
                  id="kyc_completed"
                  checked={value}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => 
                    onChange(e.target.checked)
                  }    
                />
              )}
            />
            {errors["kyc_completed"] ? (
              <p className="error-text">
                <span className="font-medium">
                  {errors?.kyc_completed.message}
                </span>
              </p>
            ) : null}
          </div>
        </div>
        <div className="grid gap-x-4 sm:grid-cols-6 gap-y-2 col-span-full sm:col-span-6 sm:order-6">
          <div className="sm:col-span-2">
            <p className="font-medium">
              Face matching time
            </p>
          </div>
          <div className="sm:col-span-4">
            <Input
              id="face_matching_time"
              type="number"
              min={0}
              placeholder="Face matching time"
              error={errors["face_matching_time"]}
              {...register("face_matching_time", {
                valueAsNumber: true
              })}
            />
            {errors["face_matching_time"] ? (
              <p className="error-text">
                <span className="font-medium">
                  {errors?.face_matching_time.message}
                </span>
              </p>
            ) : null}
          </div>
        </div>
        <div className="grid gap-x-4 sm:grid-cols-6 gap-y-2 col-span-full sm:col-span-6 sm:order-8">
          <div className="sm:col-span-2">
            <p className="font-medium">
              Phone pick
            </p>
          </div>
          <div className="sm:col-span-4">
            <Input
              id="phone_pick"
              type="text"
              placeholder="Phone pick"
              error={errors["phone_pick"]}
              {...register("phone_pick")}
            />
            {errors["phone_pick"] ? (
              <p className="error-text">
                <span className="font-medium">
                  {errors?.phone_pick.message}
                </span>
              </p>
            ) : null}
          </div>
        </div>
        <div className="grid gap-x-4 sm:grid-cols-6 gap-y-2 col-span-full sm:col-span-6 sm:order-10">
          <div className="sm:col-span-2">
            <p className="font-medium">
              ID card pick
            </p>
          </div>
          <div className="sm:col-span-4">
            <Input
              id="id_card_pick"
              type="text"
              placeholder="ID card pick"
              error={errors["id_card_pick"]}
              {...register("id_card_pick")}
            />
            {errors["id_card_pick"] ? (
              <p className="error-text">
                <span className="font-medium">
                  {errors?.id_card_pick.message}
                </span>
              </p>
            ) : null}
          </div>
        </div>
        <div className="grid gap-x-4 sm:grid-cols-6 gap-y-2 col-span-full sm:col-span-6 sm:order-12">
          <div className="sm:col-span-2">
            <p className="font-medium">
              Max number of times to update authorized info
            </p>
          </div>
          <div className="sm:col-span-4">
            <Input
              id="num_of_times_update_authorized_info"
              type="number"
              min={0}
              placeholder="Max number of times to update authorized info"
              error={errors["num_of_times_update_authorized_info"]}
              {...register("num_of_times_update_authorized_info", {
                valueAsNumber: true
              })}
            />
            {errors["num_of_times_update_authorized_info"] ? (
              <p className="error-text">
                <span className="font-medium">
                  {errors?.num_of_times_update_authorized_info.message}
                </span>
              </p>
            ) : null}
          </div>
        </div>
      </div>
    </CollapsibleSection>
  )
}